import React, { useState, useEffect, useMemo } from "react";
import { Row } from "antd";
// import { useParams, useNavigate } from "react-router-dom";
import Image from "next/image";
import { useRouter } from "next/router";
import Backpage from "../../utils/Backpage";
import Slider from "react-slick";
import KnowMore from "../../utils/KnowMore";
import officelistingStyle from "../../../styles/sass/office-listing.module.scss";
import gridIcon from "../../../../public/assets/images/grid-icon.svg";
/* import Tourform from "../../utils/Tourform"; */
/* import Loading from "../../utils/Loading";
import Notfound from "../notfound/Notfound"; */
// import { data } from "../../../services/data.js";
/* import Enqiurybtn from "./Enqiurybtn"; */
import { useDispatch, useSelector } from "react-redux";
// import { getAllCMS } from "../../../redux/cms/CMSActions";
import { resourceTypes, setHeaderSpace } from "../../../utils/CommonFunctions";
import Overview from "../../common-components/overview/Overview";
import Blog from "../../common-components/blog/Blog";
import Faqs from "../../common-components/faqs/Faqs";
import ContentContainer from "./components/ContentContainer";
import BenefitsContainer from "./components/BenefitsContainer";
import constants from "../../../utils/Constants";
import Bookonlinebtn from "../../utils/Bookonlinebtn";

/* const Officedetail = ({ tourForm, tourFormToggle }) => { */
const Officedetail = () => {
  //const dispatch = useDispatch();

  const [dimensions, setDimensions] = useState({
    width: typeof window !== "undefined" && window?.innerWidth,
  });
  const [folds, setFolds] = useState([]);
  const [activeThumb, setActiveThumb] = useState(false);
  // const { deskName } = useParams();
  // const history = useNavigate();
  const router = useRouter();
  const { deskName } = router.query;

  const [showKnowMore, setShowKnowMore] = useState(false);

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  // const [boardKey, setBoardKey] = useState({});

  const { cmsMap, boards } = useSelector(({ cms }) => cms);

  const cmsBoard = useMemo(() => {
    let resource_type = deskName;
    Object.values(resourceTypes).forEach(({ _id, cms_id, active, folds }) => {
      if (_id === deskName && active) {
        resource_type = cms_id;
        setFolds(folds);
      }
    });

    const boardKey = JSON.stringify({ type: "ImageGallery", resource_type });
    return boards?.[boardKey];
  }, [boards, deskName]);

  const knowMoreId = useMemo(() => {
    let resource_type = deskName;
    Object.values(resourceTypes).forEach(({ _id, cms_id, active }) => {
      if (_id === deskName && active) {
        resource_type = cms_id;
      }
    });

    const boardKey = JSON.stringify({ type: "KnowMore", resource_type });
    return boards?.[boardKey]?.list?.[0];
  }, [boards, deskName]);

  const resourceGallery = useMemo(() => {
    const id = cmsBoard?.list?.[0];
    return cmsMap?.[id];
  }, [cmsMap, cmsBoard]);

  const resourceName = useMemo(() => {
    return (
      resourceGallery?.name ||
      resourceTypes[resourceGallery?.meta?.resource_type]?.name
    );
  }, [resourceGallery]);

  const handleResize = () => {
    setDimensions({
      width: typeof window !== "undefined" && window.innerWidth,
      /*  height: window.innerHeight, */
    });
  };

  useEffect(() => {
    typeof window !== "undefined" &&
      window.addEventListener("resize", handleResize, false);
  }, []);

  /* for set header */
  useEffect(() => {
    setHeaderSpace();
  }, []);

  // useEffect(() => {
  //   const params = { type: "ImageGallery", resource_type: deskName };
  //   setBoardKey(params);
  //   // !cmsBoard && dispatch(getAllCMS(params));
  // }, [deskName, cmsBoard]);

  const settings = useMemo(
    () => ({
      dots: false,
      infinite: false,
      speed: 1000,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      arrows: false,
      autoplaySpeed: 6000,
      responsive: [
      
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    }),
    []
  );

    const settings2 = {
    dots: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    swipeToSlide: true,
    focusOnSelect: true,
    arrows: true,
      responsive: [
    
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  /* if (!cmsBoard || (!cmsBoard?.list && cmsBoard?.loading)) {
    return <Loading />;
  } else if (!cmsBoard?.list?.length) {
    return <Notfound />;
  } */

  return (
    <>
      {/* <KnowMore
        spaceId={knowMoreId}
        show={showKnowMore}
        handleDrawer={() => setShowKnowMore(false)}
      /> */}
      <section className={`header-container-outer-box ${officelistingStyle["setHeightBanner"]}`}>
        <div id="setSpacer" className="setBanner">
          <div className="bannerInner">
            {/* set_loading_cb */}
            <div
              className={`${officelistingStyle["ol_d_cb"]}  ${officelistingStyle["activeFormCon"]} fullHeightSlider`}>
              {/* <div className="loader_cb">
              <div className="loading_text_data">Loading Image...</div>
              <div className="loading-spinner"></div>
            </div> */}

              <Slider
                className="slider_full_cb"
                {...settings}
                asNavFor={nav2}
                ref={(slider1) => setNav1(slider1)}
              >
                {resourceGallery?.pictures?.sort((a, b) => a?.extra?.order - b?.extra?.order)?.map((picture, i) => (
                  <div className={`${officelistingStyle["slideItem"]} mobile-design-cb`} key={i}>
                    <div
                      className={`${officelistingStyle["innerItem"]} inner-m-cb`}
                      style={{ backgroundImage: `url(${picture?.url})` }}
                    />
                  </div>
                ))}
              </Slider>

              <div className={officelistingStyle.headingbanner}>
                <h1 className={officelistingStyle.title}>{resourceName}</h1>
              </div>


              <div className={`${officelistingStyle["ol_s_nav"]} ${activeThumb ? officelistingStyle["activeSlider"] : ""}`}>
                <div className={`${officelistingStyle["grid-icon-cb"]}`} onClick={()=> setActiveThumb(!activeThumb)}>
                   <Image src={gridIcon.src} alt="grid icon" width={24} height={24} />
                </div>
                <div className={`${officelistingStyle.ol_s_inner_nav} office_listing_style`}
                >
                  {/* <h1 className={officelistingStyle.title}>{resourceName}</h1> */}

                  {/* <Row justify="end">
                    <span
                      className="km_btn"
                      onClick={() => setShowKnowMore(true)}
                    >
                      Know More
                    </span>
                  </Row> */}

                  <Slider
                    asNavFor={nav1}
                    ref={(slider2) => setNav2(slider2)}
                    {...settings2}
                  >
                    {resourceGallery?.pictures?.sort((a, b) => a?.extra?.order - b?.extra?.order)?.map((picture, i) => (
                      <div className={officelistingStyle.navSlideItem} key={i}>
                        <div
                          className={`${officelistingStyle.nav_i_s_item} loading_cb slider_thumb_height nav_i_cb_inner`}
                        >
                          <div className="loading-spinner"></div>
                          <Image
                            className={officelistingStyle.full_image}
                            height={66}
                            width={116}
                            src={picture?.thumb_location}
                            // layout="fill"
                            loader={() => picture?.thumb_location}
                            alt={picture?.tag || resourceName}
                            loading="lazy"
                            unoptimized={true}
                          />
                        </div>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>

            <div className="btn_booking-online hide-mobile">
              <Bookonlinebtn />
            </div>

          </div>
        </div>
      </section>

      {/* <Overview />
      <BenefitsContainer />
      <ContentContainer />
      <Overview />
      <Blog />
      <Faqs /> */}

      {folds?.map((fold) => {
        const { Component, _id } = fold;
        const mCMS = cmsMap[_id];
        if (mCMS?.active) return <Component key={_id} data={mCMS} />;
      })}

      {/* <Tourform tourForm={tourForm} tourFormToggle={tourFormToggle} /> */}
      {/* <Backpage /> */}
      {/* <Enqiurybtn tourFormToggle={tourFormToggle} /> */}
    </>
  );
};

export default Officedetail;
